/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { Button } from "reactstrap";
import { BlurSpinner } from "../../../components/BlurSpinner";
import { Container, ContainerError, CustomLabel } from "./styles";
import { InputText } from "../../../ui/inputs";
import { ButtonPrimary } from "../../../ui/buttons";
import { handleErrors } from "../../../services/handleErrors";
import { InputFile } from "../../../components/RelevosInfoGeneral/styles";
import { patchFile, uploadFiles } from "../../../services/fileServices";
import { createPlaybook, deletePlaybook, updatePlaybook } from "../../../services/playbookServices";

export const createOrUpdatePlaybook = async (data, id) => {
  if (id) {
    const res = await updatePlaybook(id, data);
    return res;
  }
  const res = await createPlaybook(data);
  return res;
};

export default function PlaybookForm({ clientId, razonSocial, toggle, refreshData }) {
  const [fileName, setFileName] = useState("Seleccione un archivo");
  const [fileId, setFileId] = useState(false);
  const [files, setFiles] = useState(null);
  const [isLoadingFiles, setIsLoadingFiles] = useState(false);
  const [isError, setIsError] = useState(null);

  useEffect(() => {
    if (!clientId) {
      toast.error("Falta el dato cliente id");
    }
    if (!razonSocial) {
      toast.error("Falta el dato razon social");
    }
  }, []);

  const uploadOrPatchFiles = async (id) => {
    setIsLoadingFiles(true);

    if (fileId !== false) {
      const file = await patchFile({ entity: "playbook", entityId: id, fileId, files });
      setFileId(file.result.id);
    } else {
      const file = await uploadFiles({ entity: "playbook", entityId: id, files });
      setFileId(file.result[0].id);
    }
    setIsLoadingFiles(false);
  };

  const handleFileChange = (e) => {
    const selectedFiles = e.target.files;
    setFileName(selectedFiles[0].name);
    setFiles(selectedFiles);
  };
  const formik = useFormik({
    initialValues: {
      clientId,
      razonSocial,
    },

    onSubmit: async (values) => {
      setIsError(null);

      if (!values.razonSocial) {
        toast.error("El Cliente no tiene razón social");
        return;
      }

      const dataToCreate = { ...values };

      try {
        const { message, result } = await createOrUpdatePlaybook(dataToCreate, null);

        try {
          await uploadOrPatchFiles(result.id);
          toast.success(message);
          toggle();
          refreshData();
        } catch (error) {
          setIsError(error.message);
          deletePlaybook(result.id);
        }
      } catch (error) {
        handleErrors(error, toast.error, null, formik);
        toggle();
      } finally {
        setIsLoadingFiles(false);
      }
    },
  });

  return (
    <>
      <BlurSpinner>
        <Container>
          <form onSubmit={formik.handleSubmit}>
            <div>
              <div className="d-flex flex-column justify-content-between align-items-start">
                <div className="w-100 mb-3">
                  <div>
                    {isError && (
                      <ContainerError>
                        <p className="m-0">{isError || "Archivo no permitido"}</p>
                      </ContainerError>
                    )}
                    <div className="mb-3">
                      <CustomLabel>Archivo Playbook</CustomLabel>
                      <div className="custom-file">
                        <InputText
                          className="custom-file-input"
                          type="file"
                          id="upfile"
                          onChange={handleFileChange}
                          accept=".pdf, .xls, .xlsx, .doc, .docx, .jpg, .jpeg, .png"
                          style={{ cursor: "pointer", border: "none" }}
                          disabled={formik.isSubmitting}
                        />
                        <InputFile className="custom-file-label" htmlFor="upfile">
                          {fileName}
                        </InputFile>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-end">
                <Button className="mr-2" size="sm" color="btn" type="button" onClick={() => toggle()} disabled={formik.isSubmitting || isLoadingFiles}>
                  Cancelar
                </Button>
                <ButtonPrimary size="sm" type="submit" disabled={formik.isSubmitting || isLoadingFiles || !files}>
                  Guardar
                </ButtonPrimary>
              </div>
            </div>
          </form>
        </Container>
      </BlurSpinner>
    </>
  );
}
